import { render, staticRenderFns } from "./rmu-revenue-icon.vue?vue&type=template&id=50430e70"
import script from "./rmu-revenue-icon.vue?vue&type=script&lang=js"
export * from "./rmu-revenue-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports